import { protectedComponentHoc } from "../../components/ProtectedComponent";
import ImportTranslationsComponent from "./component";

export const ImportTranslations = protectedComponentHoc(
  ImportTranslationsComponent
);
